import { useState, useEffect } from 'react';
import { Col, Modal } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';

const ProjectScreenshotsComponent = ({ imagesList, imageSize }: { imagesList: any, imageSize: number }) => {
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
    const [hovered, setHovered] = useState(false);
    const clickable = imageSize !== 12;

    const goTo = (index: number) => {
        if (index < 0) index = imagesList.length - 1;
        if (index >= imagesList.length) index = 0;
        setSelectedIndex(index);
    };

    useEffect(() => {
        if (selectedIndex === null) return;
        const handleKey = (e: KeyboardEvent) => {
            if (e.key === 'ArrowLeft') goTo(selectedIndex - 1);
            if (e.key === 'ArrowRight') goTo(selectedIndex + 1);
        };
        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [selectedIndex]);

    return (
        <>
            <section className="row">
                { imagesList.map((item: any, i: number) => (
                    <Col key={item.imageLink} xs={12} lg={imageSize} className="mb-4">
                        <Image 
                            src={item.imageLink}
                            alt={item.altText}
                            fluid
                            className={`project-screenshots${clickable ? ' clickable' : ''}`}
                            onClick={clickable ? () => setSelectedIndex(i) : undefined}
                            style={clickable ? { cursor: 'pointer' } : undefined}
                        />   
                    </Col>         
                ))}
            </section>

            <Modal show={selectedIndex !== null} onHide={() => setSelectedIndex(null)} size="xl" centered>
                <Modal.Body className="text-center p-0 position-relative" onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
                    {selectedIndex !== null && (
                        <>
                            <Image src={imagesList[selectedIndex].imageLink} alt={imagesList[selectedIndex].altText} fluid style={{ maxHeight: '90vh', width: 'auto', borderRadius: '6px' }} />
                            {imagesList.length > 1 && hovered && (
                                <>
                                    <button onClick={() => goTo(selectedIndex - 1)} className="btn btn-dark position-absolute top-50 start-0 translate-middle-y ms-2 opacity-75" style={{ zIndex: 10 }}>&#8249;</button>
                                    <button onClick={() => goTo(selectedIndex + 1)} className="btn btn-dark position-absolute top-50 end-0 translate-middle-y me-2 opacity-75" style={{ zIndex: 10 }}>&#8250;</button>
                                    <div className="position-absolute bottom-0 start-50 translate-middle-x mb-2 text-white bg-dark bg-opacity-50 px-2 py-1 rounded" style={{ fontSize: '0.85rem' }}>{selectedIndex + 1} / {imagesList.length}</div>
                                </>
                            )}
                        </>
                    )}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ProjectScreenshotsComponent;